import { render, staticRenderFns } from "./CustTable.vue?vue&type=template&id=5f660754"
import script from "./CustTable.vue?vue&type=script&lang=js"
export * from "./CustTable.vue?vue&type=script&lang=js"
import style0 from "./CustTable.vue?vue&type=style&index=0&id=5f660754&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports